//Author June Leow
//Date Mar 25th, 2024
import {getReducer, getSetStateFunction, deleteAPICallGenerator, callBackGenerator, formatNumber, showMessage} from '../../../../util/util';
import {Card, CardHeader, CardBody, Input} from 'reactstrap';
import Compressor from 'compressorjs';
import Dropzone from 'react-dropzone'
import React, {useReducer, useEffect} from 'react';
//initialize the state
const initialState = {

};

//reducer function that perform state update
const reducer = getReducer();


const StepPhoto  = (props)=>{
  const controller = new AbortController();

  const [state, dispatch] = useReducer(reducer,initialState);

  //wrapper function
  const setState = getSetStateFunction(dispatch);

  const apiCallBack = callBackGenerator(setState);
  const httpDelete = deleteAPICallGenerator(props, {signal:controller.signal});

  //run only once when component is loaded
  useEffect(()=>{
    return ()=> controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  //non API call but simpyl manage state
  const getCompressRatio = (size)=>{
    let ratio = 0.8;
    size = size/1000/1000;
  
    if(size>=20)
      ratio = 0.05;
    else if(size>=15)
      ratio = 0.05;
    else if(size>=10)
      ratio = 0.1;
    else if(size>=8)
      ratio = 0.2;
    else if(size>=6)
      ratio = 0.4;
    else if(size>=4)
      ratio = 0.5;
    else if(size>=3)
      ratio = 0.6;
    else if(size>=2)
      ratio = 0.7;
  
    return ratio;
  }

  const removeFile = (field,index)=>{
    let newUPD = Object.assign({}, props.upd);
    let target = newUPD[field];

    let targetToDelete = target[index];

    if(targetToDelete.ID && targetToDelete.ID!==-1){
      let successCallBack = ()=>{
        target.splice(index, 1);
        newUPD[field] = target;
        props.update(newUPD);
      };
      successCallBack = successCallBack.bind(this);
      deletePhoto(targetToDelete.ID, props, successCallBack);
    }
    else{
      target.splice(index, 1);
      newUPD[field] = target;
      props.update(newUPD);
    }

  }

  //function trigger for dropzone react.
  //this function contians two list of files, the accepted and rejected file per the configuration
  const onDrop = (acceptedFiles, rejectedFiles, field, type='Misc', typeFk=0, description='')=>{
    let existingFiles = [];
    if(acceptedFiles.length>0){
      for(let i=0;i<acceptedFiles.length;i++){
        existingFiles.push(acceptedFiles[i]);
        let name = existingFiles[i].name;
        let token = name.split('.');
        let extension = '';

        if(token.length>0){
          extension = token[token.length-1];
          extension = extension.toLowerCase();
        }

        if(extension!=='png'&&extension!=='jpg'&&extension!=='jpeg'){
          showMessage('error','Please upload only PNG/JPG image.');
        }
        else if((acceptedFiles[i].size/1000/1000)<1){
          showMessage('error','Image quality is too low, please use photo that range from 1MB to 50MB.');
        }
        else if((acceptedFiles[i].size/1000/1000)>50){
          showMessage('error','Image size is too large, please use photo that range from 1MB to 50MB.');
        }
        else{
          let compressRatio = getCompressRatio(acceptedFiles[i].size);
          new Compressor(acceptedFiles[i], {
            quality: compressRatio, // 0.6 can also be used, but its not recommended to go below.
            success: (compressedResult) => {
              // compressedResult has the compressed file.
              // Use the compressed file to upload the images to your server.        
              let compressedFile = new File([compressedResult], acceptedFiles[i].name);

              const reader = new FileReader();
              reader.onload = () => {
                const fileAsBinaryString = reader.result;
                let base64 = btoa(fileAsBinaryString);
                let newUPD = Object.assign({}, props.upd);
                let target = newUPD[field]?newUPD[field]:[];
  
                target.push({name:acceptedFiles[i].name, base64:base64, status:'Pending', size:compressedFile.size, type:type, typeFk:typeFk, description:description});
                newUPD[field] = target;
                props.update(newUPD);
              }
              reader.readAsBinaryString(compressedFile);
            },
          });
        }
      }
    }
  }

  //format the size to use appropiate unit KB, MB and B and round up to only 1 decimal
  const formatFileSize = (size)=>{
    let intSize = parseInt(size,10);

    if(intSize>=1000000.00)
      return formatNumber(Math.round((intSize*10/1000000))/10)+' MB';
    else if(intSize>=1000)
      return formatNumber(Math.round((intSize*10/1000))/10)+' KB';
    else
      return formatNumber(intSize)+' B';

  }

  const updateFileDescription = (fileName, value)=>{
    let newUPD = Object.assign({}, props.upd);
    let toUploadFiles = newUPD.photos.slice();

    for(let i=0;i<toUploadFiles.length;i++){
      if(toUploadFiles[i].name===fileName){
        toUploadFiles[i].description = value;
        break;
      }
    }

    newUPD.photos = toUploadFiles;
    props.update(newUPD);
  }

  //API call
  const deletePhoto = (ID, props, successCallBack) => {
    let callBack = apiCallBack([],[()=>{successCallBack()}])
    httpDelete('uniformPropertyDataset/photo/'+ID, '', 'Oops, something went wrong and could not delete this photo. Please try again later.', callBack);
  }

  //render
  let disabledStyling = {border:'none', background:'#fff', padding:'0',paddingLeft:'2px', height:'auto',WebkitAppearance:'none'};
  let toUploadFiles;

  if(props.upd.photos.length>0){
    toUploadFiles = props.upd.photos.map(
      (photo,index)=>{
        return(
          <tr key={index}>
            <td>{photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}</td>
            <td>
              <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} type="text" value={photo.description} onChange={(e)=>updateFileDescription(photo.name, e.target.value)}/>
            </td>
            <td>{formatFileSize(photo.size)}</td>
            <td><center>{photo.status}</center></td>
            <td><center><i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={()=>removeFile('photos',index)}></i></center></td>
          </tr>
        );
      }
    );
  }

  return <div>
    <Card>
      <CardHeader className="header-color">
        Extra Photos
      </CardHeader>
      <CardBody>
        <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, 'photos', 'OTHER', 0)}} className="my-dropzone">
          {
            ({getRootProps, getInputProps}) => (
              <div
                {...getRootProps({
                  className: 'my-dropzone',
                })}
              >
                <input {...getInputProps()} />
                <center>
                  <font style={{fontSize:'60px'}}>
                    <i className="fa fa-cloud-upload link-color"></i>
                  </font>
                  <br/>
                  Choose files to upload
                  <br/>
                  <div className="margin-top">
                    <i><b>OR drag and drop file here.</b></i>
                  </div>
                </center>
              </div>
            )
          }
        </Dropzone>
        <br/>
        <div className="my-divider"></div>
        <div style={{minHeight:'35px',maxHeight:'35px'}} className="red-color flashit">
          <b>{state.errorMessage}</b>
        </div>
        <div className="large-scroll-container">
          <table className="table file-list-table" cellSpacing="0" cellPadding="0">
            <thead>
              <tr>
                <th width="30%">Name</th>
                <th width="35%">Description</th>
                <th width="15%">Size</th>
                <th width="10%"><center>Status</center></th>
                <th width="10%">Control</th>
              </tr>
            </thead>
            <tbody>
              {toUploadFiles}
            </tbody>
          </table>
          {
            !props.upd.photos?null:props.upd.photos.map(
              (photo, index)=>{
                return <div key={index} className="display-inline" style={{width:200, height:250, margin:5}}>
                  <div>
                    <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('photos',index)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                  </div>
                  <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                </div>
              }
            )
          }
        </div>
      </CardBody>
    </Card>
  </div>
}


export default StepPhoto;